import { ResizeSimpleAction } from '@cloudinary/url-gen/actions/resize/ResizeSimpleAction'
import { useQuery } from '@tanstack/react-query'

import { useAuth } from '@/auth/hooks/useAuth'
import { cloudinary } from '@/cloudinary/cloudinary'
import {
  CloudinaryImage,
  CloudinaryImageProps,
} from '@/cloudinary/CloudinaryImage'
import { companyQueries } from '@/http/api/company'

type CompanyLogoProps = Omit<CloudinaryImageProps, 'image'> & {
  resize?: ResizeSimpleAction
}

export function CompanyLogo({
  resize,
  className,
  ...imageProps
}: CompanyLogoProps) {
  const { isAuthenticated } = useAuth()
  const company = useQuery({
    ...companyQueries.detail(),
    enabled: isAuthenticated,
  })
  const companyLogo = company.data?.logo_id

  if (!companyLogo) {
    return null
  }

  const image = cloudinary.image(companyLogo)
  if (resize) {
    image.resize(resize)
  }

  return <CloudinaryImage image={image} className={className} {...imageProps} />
}

export default CompanyLogo
